export class PostCrearJornadaResquestDTO {

  uuid: string;
  fechaInicio: string;
  fechaTermino: string;
  conductor: {
    uuid: string;
  }

  constructor() {
    this.conductor = { uuid: '' };
  }

}
